module.exports = __webpack_public_path__ + "display/static/img/icon-d.4ef3abb.svg";


//////////////////
// WEBPACK FOOTER
// ./~/tui-image-editor/dist/svg/icon-d.svg
// module id = 774
// module chunks = 1 3